<template>
	<v-layout row wrap align-center class="section-brand" background>
		<div class="container">
			<v-layout wrap>
				<v-flex xs12 md6 class="section-brand-left">
					<a :href="landingLink" target="_blank">
						<img src="/static/images/logos/logo-casa-market-orange.svg" alt="logo CasaMarket" class="section-brand-image" />
					</a>
				</v-flex>
				<v-flex xs12 md6 class="section-brand-right">
					<a :href="facebookUrl" target="_blank" class="btn-image image-facebook">
						<img src="/static/images/logos/logo-facebook.svg" alt="facebook mi bodega" height="54" />
					</a>
					<a :href="instagramUrl" target="_blank" class="btn-image image-instagram">
						<img src="/static/images/logos/logo-instagram.svg" alt="instagram mi bodega" height="54" />
					</a>
				</v-flex>
			</v-layout>
		</div>
	</v-layout>
</template>

<script>
	function data() {
		return {
			landingLink: process.env.ORDER_LINK,
			facebookUrl: process.env.FACEBOOK_LINK,
			instagramUrl: process.env.INSTAGRAM_LINK,
		};
	}

	export default {
		name: 'section-brand',
		data,
	};
</script>

<style lang="scss" scoped>
	.section-brand {
		padding: 40px 3%;

		@media (min-width: 360px) {
			padding: 40px 5%;
		}

		@media (min-width: 1024px) {
			padding: 40px 10%;
		}

		@media (min-width: 1280px) {
			padding: 40px 11%;
		}

		@media (min-width: 1400px) {
			padding: 40px 13%;
		}

		&-left {
			margin-bottom: 53px;
			text-align: center;

			@media (min-width: 1024px) {
				margin-bottom: 0px;
				text-align: left;
			}
		}

		&-right {
			text-align: center;

			@media (min-width: 1024px) {
				text-align: right;
			}
		}

		&-image {
			height: auto;
			max-width: 100%;

			@media (min-width: 1024px) {
				height: 89px;
			}
		}

		.image-facebook {
			margin-right: 28px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-brand.vue